export function startAccount(dataToAccount, setToken, textSavePay,  setTextSavePay, setNamesPaid) {

    let textSave = '';
    let allowedToSave = false;
    let getAprice = true;

    if (dataToAccount['status'] !== 5) {
        let namesPaid2 = {};

        if (dataToAccount['status'] === 0) {
            let save = JSON.parse(dataToAccount['save']);
            setToken(save['token']);
            let dateSave = new Date(Number(save['time']) * 1000);

            textSave = `שמור עד - ${dateSave.getHours()}:${dateSave.getMinutes() < 10 ? "0" + dateSave.getMinutes() : dateSave.getMinutes()} 
            ${dateSave.getDate() < 10 ? "0" + dateSave.getDate(): dateSave.getDate()}/${dateSave.getMonth() < 9 ? "0" + (dateSave.getMonth() + 1): dateSave.getMonth() + 1}`;

            allowedToSave = true;
        } else if (dataToAccount['status'] === 2) {
            textSave = 'שולם מקדמה';
        } else if (dataToAccount['status'] === 1) {
            textSave = 'הזמנה סגורה';
        } else if (dataToAccount['status'] === 3) {
            textSave = 'הזמנה נפלה';
            getAprice = false;
        }

        const invoices = JSON.parse(dataToAccount['invoices']);

        Object.keys(invoices).length && Object.values(invoices).map((invoicesData) => {

            Object.keys(invoicesData['d']).map((keyName) => {
                if (keyName in namesPaid2) {
                    namesPaid2[keyName] = invoicesData['d'][keyName] + namesPaid2[keyName]
                } else {
                    namesPaid2[keyName] = invoicesData['d'][keyName]
                }
            })
        })

        setNamesPaid(namesPaid2);

    } else {
        textSave = 'שמירת הזמנה';
        allowedToSave = true;
    }

    setTextSavePay({save: textSave, pay: textSavePay.pay, allowedToSave: allowedToSave});
}